module.exports = __webpack_public_path__ + "img/2.39c32219.png";